const closePaneByWindowId = new Map<string, () => boolean>()

export function registerWindowPaneBack({
    windowId,
    closeOpenPane,
}: {
    windowId: string
    closeOpenPane: () => boolean
}): () => void {
    closePaneByWindowId.set(windowId, closeOpenPane)
    return () => {
        if (closePaneByWindowId.get(windowId) === closeOpenPane) {
            closePaneByWindowId.delete(windowId)
        }
    }
}

export function closeWindowPane(windowId: string): boolean {
    return closePaneByWindowId.get(windowId)?.() ?? false
}
